import React, { useState } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { ExportService } from "../services/exportService";
import { useViewedEntityName } from "../hooks/useViewedEntityName";

// Import the name store

interface ExportMenuProps {
  data: Record<string, any>[]; // הנתונים שיתקבלו כ-prop
  filename?: string; // שם הקובץ האופציונלי
  includeUsername?: boolean; // האם לכלול את שם המשתמש בשם הקובץ
}

export const ExportMenu: React.FC<ExportMenuProps> = ({
  data,
  filename,
  includeUsername = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const username = useViewedEntityName();

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const getFilename = (baseFilename: string | undefined) => {
    if (!baseFilename) return undefined;
    return includeUsername ? `${baseFilename}_${username}` : baseFilename;
  };

  const handleExportAsCSV = () => {
    ExportService.exportAsCSV(data, getFilename(filename));
    handleCloseMenu();
  };

  const handleExportAsExcel = () => {
    ExportService.exportAsExcel(data, getFilename(filename));
    handleCloseMenu();
  };

  return (
    <div>
      {/* כפתור אייקון לפתיחת התפריט */}
      <IconButton onClick={handleOpenMenu}>
        <DownloadIcon />
      </IconButton>

      {/* תפריט עם שתי אופציות */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleExportAsCSV}>Export as CSV</MenuItem>
        <MenuItem onClick={handleExportAsExcel}>Export as Excel</MenuItem>
      </Menu>
    </div>
  );
};
